import { observer } from 'mobx-react'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { StoresContext } from '@App/contexts'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import { PaginationBody } from '@Entities/pagination'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import PaginationComponent from '@Components/Tables/Pagination'
import { SongwriterSummary } from '@Entities/songwriter/songwriter-summary'
import SongwriterSummaryCard from '@Components/Cards/SongwriterSummaryCard'
import SearchInput from '@Components/Search/SearchInput'

const SongwriterInternalScene = () => {
    const { songwriterSearchStore, popupStore } = useContext(StoresContext)
    const [preloaderIsOpen, setPreloaderIsOpen] = useState<boolean>(false)
    const [searchValue, setSearchValue] = useState<string>(songwriterSearchStore.currentSearchValue)
    const didMount = useRef(false)
    const limitItems = 50

    useEffect(() => {
        analyticsSendPage('home_internal')
        if (!didMount.current && songwriterSearchStore.songwriters) {
            didMount.current = true
            return
        }

        didMount.current = true
        eventGetSongwriters().then()
    }, [searchValue])

    const eventGetSongwriters = async (callBackPagination?: PaginationBody) => {
        let pagination: PaginationBody = {
            page: 1,
            limit: limitItems,
        }

        if (callBackPagination) {
            pagination = {
                ...pagination,
                ...callBackPagination,
            }
        }

        try {
            setPreloaderIsOpen(true)
            await songwriterSearchStore.loadSongwriters(pagination, searchValue)
        } catch (ignore) {
            popupStore.setAlertData('Could not load songwriters', true)
        } finally {
            setPreloaderIsOpen(false)
        }
    }

    return (
        <div className="home-internal-accounts-tab">
            <div className="search-all-block">
                <p>
                    {songwriterSearchStore.songwriters && songwriterSearchStore.songwriters.totalElements} Songwriters
                </p>
                <SearchInput
                    id="songwriter-search"
                    placeholder="Search Songwriters"
                    buttonClick={setSearchValue}
                    onClearInput={() => setSearchValue('')}
                    value={songwriterSearchStore.currentSearchValue}
                />
            </div>
            <div className="accounts-block">
                {preloaderIsOpen ? (
                    <PointPreloader />
                ) : (
                    songwriterSearchStore.songwriters?.content.map((item: SongwriterSummary) => (
                        <SongwriterSummaryCard key={item.id} {...item} />
                    ))
                )}
                {!preloaderIsOpen &&
                    songwriterSearchStore.songwriters &&
                    !songwriterSearchStore.songwriters.totalElements && (
                        <p className="small no-results">No Songwriters</p>
                    )}
            </div>
            <PaginationComponent
                limit={limitItems}
                paginationPages={songwriterSearchStore.paginationInfo}
                onChange={eventGetSongwriters}
            />
        </div>
    )
}

export default observer(SongwriterInternalScene)
